document.addEventListener("DOMContentLoaded", function () {
  const tradeSelectorInput = document.querySelector(".js-trade-input");
  const { journeyName } = document.querySelector("body").dataset;

  const body = document.querySelector("body");
  const generalContractorModal = document.querySelector(
    ".general-contractor-modal",
  );

  const disableBodyScrolling = () =>
    body.classList.add("general-contractor-modal-open");

  const enableBodyScrolling = () =>
    body.classList.remove("general-contractor-modal-open");

  function clearTrade() {
    const element = $(".js-ai-trade-search-wrapper");
    if (element.length > 0) {
      element.find(".js-ai-change").click();
      element.find(".js-ai-trade-search").val("");
      element.find(".js-ai-trade-search").trigger("change");
      element.find(".ai-results").hide();
    } else {
      const tradeInput = $(".trade-search-input");
      tradeInput.val("");
      tradeInput.trigger("input");
      $(".js-change").click();
    }
  }

  async function setHandypersonTrade() {
    const element = $(".js-ai-trade-search-wrapper");
    const trade = "Handyperson";

    if (element.length > 0) {
      element.find(".js-trade-input").val(trade);
      element.find(".js-trade-input").trigger("change");
      element.find(".answer").text(trade);
      element.parent().removeClass("state-search").addClass("state-selected");
      element.find(".ai-search-input-wrapper").hide();
    } else {
      $(".js-change").click();
      await sleep(400);
      const tradeInput = $(".trade-search-input");
      tradeInput.val(trade);
      tradeInput.trigger("input");
      const elemet = document.querySelector('li[data-value="Handyperson"]');
      elemet.click();
    }
  }

  function sleep(ms) {
    return new Promise((resolve) => {
      setTimeout(resolve, ms);
    });
  }

  document
    .querySelectorAll(".js-general-contractor-modal-no")
    .forEach((elem) => {
      elem.addEventListener("click", (e) => {
        e.preventDefault();
        setHandypersonTrade().then(() => {
          generalContractorModal.classList.add("hide-modal");
          generalContractorModal.classList.remove("fade-in", "show-modal");
        });

        enableBodyScrolling();
      });
    });

  document
    .querySelectorAll(".js-general-contractor-modal-select-another-trade")
    .forEach((elem) => {
      elem.addEventListener("click", (e) => {
        e.preventDefault();

        generalContractorModal.classList.add("hide-modal");
        generalContractorModal.classList.remove("fade-in", "show-modal");
        enableBodyScrolling();

        clearTrade();
      });
    });

  document
    .querySelectorAll(".js-general-contractor-modal-yes")
    .forEach((element) => {
      element.addEventListener("click", (e) => {
        e.preventDefault();
        generalContractorModal.classList.add("hide-modal");
        generalContractorModal.classList.remove("fade-in", "show-modal");
        enableBodyScrolling();
      });
    });

  async function fadeInGCModal() {
    const delay = (milliseconds) => {
      return new Promise((resolve) => {
        setTimeout(resolve, milliseconds);
      });
    };

    await delay(50);

    generalContractorModal.classList.add("show-modal");

    await delay(50);
    disableBodyScrolling();
    generalContractorModal.classList.remove("hide-modal");
    generalContractorModal.classList.add("fade-in");
  }

  const userComingFromCoverageSelectionPage = document.referrer.includes(
    "/coverage_selection/",
  );

  // We have this code for when a trade is prefilled, e.g. from selecting General Contractor from /trades?vertical=usa'
  if (
    tradeSelectorInput &&
    journeyName === "coverage_selection" &&
    tradeSelectorInput.value === "General contractor" &&
    // e.g. don't show modal if user clicking back from next coverage selection page
    !userComingFromCoverageSelectionPage
  ) {
    fadeInGCModal();
  }

  if (tradeSelectorInput) {
    $(tradeSelectorInput).on("change", (e) => {
      if (e.target.value === "General contractor") {
        fadeInGCModal();
      }
    });
  }
});
